var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_setup.btnStyle(_vm.loading, _vm.disabled),on:{"click":_setup.handleClick}},[(!_vm.loading)?_c('div',[_vm._t("default")],2):_c('div',[_vm._v(_vm._s(_vm.loadingText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }